import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ThumbDownOffAltIcon from '@mui/icons-material/ThumbDownOffAlt';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbUpOffAltIcon from '@mui/icons-material/ThumbUpOffAlt';

import { useCallback, useMemo } from "react";
import { useGetAmbientScribeFeedbackQuery } from "services/ambient-scribe";
import { feedbackSoapNoteType, feedbackSummaryType, feedbackThumbDownRating, feedbackThumbUpRating, feedbackTranscriptType } from "../constants";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import { misc } from "app/themes/colors";
import { openScribeFeedbackDialog } from "../medical-scribe.slice";
import { useAppDispatch } from "app/hooks";

interface MedicalScribeFeedbackButtonsProps {
  scribeId?: number;
  feedbackType?: number;
}

export default function MedicalScribeFeedbackButtons({ scribeId, feedbackType }: MedicalScribeFeedbackButtonsProps) {

  const dispatch = useAppDispatch();

  const isSummary = feedbackType === feedbackSummaryType;
  const isSoapNotes = feedbackType === feedbackSoapNoteType;
  const isTranscript = feedbackType === feedbackTranscriptType;

  const { data: feedback = [], isFetching } = useGetAmbientScribeFeedbackQuery(
    Number(scribeId),
    {
      skip: !Number(scribeId)
    }
  );

  const transcriptFeedback = feedback.find(
    (feedback) => feedback.feedback_type === feedbackTranscriptType
  );

  const feedbackOptions = useMemo(() => {
    const summaryFeedback = feedback.find(
    (feedback) => feedback.feedback_type === feedbackSummaryType
  );

  const soapNotesFeedback = feedback.find(
    (feedback) => feedback.feedback_type === feedbackSoapNoteType
  );

    if (isFetching) return null;
    if (isSummary) {
      const isUp = summaryFeedback?.rating === feedbackThumbUpRating;
      const isDown = summaryFeedback?.rating === feedbackThumbDownRating;
      return {
        upIcon: isUp ? <ThumbUpIcon sx={{color: misc.suno}} /> : <ThumbUpOffAltIcon sx={{color: misc.suno}} />,
        downIcon: isDown ? <ThumbDownIcon sx={{color: misc.suno}} /> : <ThumbDownOffAltIcon sx={{color: misc.suno}} />,
        isUp,
        isDown


      }
    }
    if (isSoapNotes) {
      const isUp = soapNotesFeedback?.rating === feedbackThumbUpRating;
      const isDown = soapNotesFeedback?.rating === feedbackThumbDownRating;

      return {
        upIcon: isUp ? <ThumbUpIcon sx={{color: misc.suno}} /> : <ThumbUpOffAltIcon sx={{color: misc.suno}} />,
        downIcon: isDown ? <ThumbDownIcon sx={{color: misc.suno}} /> : <ThumbDownOffAltIcon sx={{color: misc.suno}} />,
        isUp,
        isDown
      }
    }
    if (isTranscript) {
      const isUp = transcriptFeedback?.rating === feedbackThumbUpRating;
      const isDown = transcriptFeedback?.rating === feedbackThumbDownRating;
      return {
        upIcon: isUp ? <ThumbUpIcon sx={{color: misc.suno}} /> : <ThumbUpOffAltIcon sx={{color: misc.suno}} />,
        downIcon: isDown ? <ThumbDownIcon sx={{color: misc.suno}} /> : <ThumbDownOffAltIcon sx={{color: misc.suno}} />,
        isUp,
        isDown
      }
    }
    return {
      upIcon: <ThumbUpOffAltIcon sx={{color: misc.suno}} />,
      downIcon: <ThumbDownOffAltIcon sx={{color: misc.suno}} />,
      isUp: false,
      isDown: false
    }
    ;
  }, [feedback, isFetching, isSoapNotes, isSummary, isTranscript, transcriptFeedback]);

  const handleUpClick = useCallback(()=>{
    if (!scribeId || !feedbackType) return;
    dispatch(openScribeFeedbackDialog({ scribeId, feedbackType, rating:feedbackThumbUpRating }));
  }, [scribeId, feedbackType, dispatch])

  const handleDownClick = useCallback(()=>{
    if (!scribeId || !feedbackType) return;
    dispatch(openScribeFeedbackDialog({ scribeId, feedbackType, rating: feedbackThumbDownRating }));
  }, [dispatch, feedbackType, scribeId])

  if (isFetching || feedbackOptions?.isUp || feedbackOptions?.isDown) {
    return null
  }

  return (
    <Stack direction="row" alignItems="center" columnGap={2} pr={2}>
      <IconButton onClick={handleUpClick}
                sx={{ border: "1px solid", borderColor: "divider", background: feedbackOptions?.isUp ? misc.subMenuItem : "transparent" }}

              >{feedbackOptions?.upIcon}
              </IconButton>

      <IconButton onClick={handleDownClick}
                color="primary"
                sx={{ border: "1px solid", borderColor: "divider", background: feedbackOptions?.isDown ? misc.subMenuItem : "transparent" }}

              >{feedbackOptions?.downIcon }
              </IconButton>
    </Stack>
  );
}